"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var DropdownWithSearch_1 = __importDefault(require("@components/DropdownWithSearch"));
function FeedbackSelector(_a) {
    var updateFeedbacks = _a.updateFeedbacks, data = _a.data, editMode = _a.editMode, selectedFeedbacksArray = _a.selectedFeedbacksArray;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: "review-feedback" },
        react_1.default.createElement("label", { className: "eva-job-section-label" }, t('ITEM.FEEDBACK.EXPLANATION')),
        react_1.default.createElement(DropdownWithSearch_1.default, { value: selectedFeedbacksArray, buttonText: t('ITEM.FEEDBACK.PLACEHOLDER'), dropDownTitle: t('ITEM.FEEDBACK.DROP_DOWN_TITLE'), data: data || [], getItemLabel: function (feedback) { return feedback.feedbackName; }, getItemId: function (feedback) { return feedback.feedbackId; }, onChange: updateFeedbacks, dropDirectionClass: "dropup", multiselect: true, dataCy: "multiselect-feedback", isDisabled: !editMode, className: "eva-keyboard-focusable" })));
}
exports.default = FeedbackSelector;
